import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import StyledDropdown from '../../../../Components/Generics.styled';
import styled from 'styled-components';
import { StyledButton } from '../../../../Components/Generics.styled';
import useRequest from '../../../../Hooks/useRequest';
import MenuItem from '@mui/material/MenuItem';

const ChooseCategoryContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: 360px;
    border: 1px solid white;
`;

const ChooseCategory = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { data: campaignTypeData } = useRequest('/getAllCampaignTypes');

    const campaignTypeCategories = campaignTypeData
        ? campaignTypeData[1]?.campaignTypeCategories
        : [];

    const { category } = { ...teachDavieData };
    const [value, setValue] = useState('');

    useEffect(() => {
        if (category !== '') {
            setValue(category);
        }
    }, [category]);

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, category: value }));
        handleNavButtonNext();
    };

    return (
        <ChooseCategoryContainer>
            <StyledDropdown
                required={true}
                error={true}
                id={'choose-category'}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                label={'Choose Your Category'}
                list={campaignTypeCategories}
                renderMenuItem={campaignTypeCategories.map((item, idx) => (
                    <MenuItem key={idx} value={item.categoryName}>
                        {item.categoryName}
                    </MenuItem>
                ))}
            />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNavButtonBack()}>Previous</Btn>
                <Btn onClick={() => handleNext()}>Next</Btn>
            </NavButtonContainer>
        </ChooseCategoryContainer>
    );
};

ChooseCategory.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

ChooseCategory.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default ChooseCategory;
